var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.62 18.12C13.0575 18.6818 12.295 18.9974 11.5 18.9974C10.705 18.9974 9.9425 18.6818 9.38 18.12L1.05 10C0.45 9.45 0 8.63 0 7.75V3C0 2.20435 0.316071 1.44129 0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0H7.75C8.63 0 9.45 0.45 10 1.05L18.07 9.43C18.6318 9.9925 18.9474 10.755 18.9474 11.55C18.9474 12.345 18.6318 13.1075 18.07 13.67L13.62 18.12ZM12.91 17.41L17.36 12.96C18.14 12.18 18.14 10.91 17.36 10.13L9.11 1.58C8.78 1.2 8.3 1 7.75 1L2.97 0.97C1.87 0.97 1 1.9 1 3V7.75C1 8.3 1.2 8.78 1.58 9.11L10.08 17.41C10.86 18.19 12.13 18.19 12.91 17.41ZM4.5 2C5.16304 2 5.79893 2.26339 6.26777 2.73223C6.73661 3.20107 7 3.83696 7 4.5C7 5.16304 6.73661 5.79893 6.26777 6.26777C5.79893 6.73661 5.16304 7 4.5 7C3.83696 7 3.20107 6.73661 2.73223 6.26777C2.26339 5.79893 2 5.16304 2 4.5C2 3.83696 2.26339 3.20107 2.73223 2.73223C3.20107 2.26339 3.83696 2 4.5 2ZM4.5 3C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5C3 4.89782 3.15804 5.27936 3.43934 5.56066C3.72064 5.84196 4.10218 6 4.5 6C4.89782 6 5.27936 5.84196 5.56066 5.56066C5.84196 5.27936 6 4.89782 6 4.5C6 4.10218 5.84196 3.72064 5.56066 3.43934C5.27936 3.15804 4.89782 3 4.5 3Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagOutlined);
export default __webpack_public_path__ + "static/media/tag_outlined.6b49e460b82239730f5ad0c7075e50c9.svg";
export { ForwardRef as ReactComponent };